"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.scrollToPosition = void 0;
/* istanbul ignore file -- wrapper */ const scrollToPosition = (top)=>{
    window.scrollTo({
        top,
        behavior: 'smooth'
    });
};
exports.scrollToPosition = scrollToPosition;
